import { Component, OnInit } from '@angular/core';
import { AuthService } from '../core/service/auth.service';
import { NgForm } from '@angular/forms/src/directives/ng_form';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  sentemail: boolean = false;
  email: string = ""

  constructor(private authService: AuthService,
              private route: ActivatedRoute) { 
                this.route.params.subscribe( params => {
                  if (params['email']){
                    this.email = params['email']; 
                    this.sentemail = true;
                  }
                });
              }

  ngOnInit() {
  }

  login(f: NgForm): void {
    this.authService.login(f.value.email, f.value.password);
  }

}



// WEBPACK FOOTER //
// C:/Users/homePC/angular-comp/The-Top/src/app/login/login.component.ts